import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { ShieldCheck } from "lucide-react";
import { useLang } from "@/i18n";
import { useAuth } from "@/context/AuthContext";
import { errMsg } from "@/api";

const inputCls = "w-full px-4 py-3 rounded-xl border border-emerald-200 bg-white focus:outline-none focus:ring-2 focus:ring-emerald-700 text-sm";

export default function AdminLogin() {
  const { t } = useLang();
  const { login } = useAuth();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [form, setForm] = useState({ mobile: "", password: "" });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const user = await login(form.mobile, form.password);
      if (user.role !== "admin") {
        toast.error("Not an admin account");
        return;
      }
      toast.success(t.login_success);
      navigate("/admin");
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-md mx-auto px-4 py-16" data-testid="admin-login-page">
      <div className="bg-emerald-950 rounded-2xl shadow-xl p-8 text-white">
        <div className="text-center mb-8">
          <div className="w-16 h-16 rounded-full bg-amber-600 flex items-center justify-center mx-auto mb-4">
            <ShieldCheck className="w-8 h-8 text-white" />
          </div>
          <h1 className="font-heading text-2xl font-bold" data-testid="admin-login-heading">{t.admin_login}</h1>
          <p className="text-sm text-emerald-300 mt-2">{t.secure_site}</p>
        </div>
        <form onSubmit={handleSubmit} className="space-y-5" data-testid="admin-login-form">
          <div>
            <label className="block text-xs font-semibold text-emerald-200 mb-1.5 uppercase tracking-wide">{t.form_mobile}</label>
            <input required value={form.mobile} onChange={(e) => setForm({ ...form, mobile: e.target.value })}
              className={`${inputCls} text-slate-900`} data-testid="admin-mobile-input" />
          </div>
          <div>
            <label className="block text-xs font-semibold text-emerald-200 mb-1.5 uppercase tracking-wide">{t.form_password}</label>
            <input required type="password" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })}
              className={`${inputCls} text-slate-900`} data-testid="admin-password-input" />
          </div>
          <button type="submit" disabled={loading} data-testid="admin-login-submit-btn"
            className="w-full py-3.5 rounded-full bg-amber-600 hover:bg-amber-700 text-white font-bold transition-all disabled:opacity-60">
            {loading ? "..." : t.login_button}
          </button>
        </form>
      </div>
    </div>
  );
}
